<template>
  <v-container fluid>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>集計表示詳細</template>
      <template v-slot:annotation
        >{{ periodNameDbUse }}の評価データの集計結果を表示します。</template
      >
    </PageHeader>
    <v-row class="pl-2 pr-0">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          loading-text="読み込み中..."
          no-data-text="集計は見つかりませんでした。"
        >
        </v-data-table>
      </v-col>
    </v-row>

    <DialogMessage ref="dialog" />
    <Loader :loading="loading" />
  </v-container>
</template>

<script>
import config from '../../../const.js';
import axios from 'axios';
import message from '../../../message.js';
import { getSessionStorageItem, convertEvaluationStatus } from '@/common.js';
export default {
  components: {},

  data() {
    return {
      crumbs: [
        {
          name: '集計表示一覧',
          route: 'SumList',
        },
        {
          name: '集計表示詳細',
          route: 'SumDetail',
        },
      ],

      loading: false,
      confirm: false,

      searchForm: {},
      userInfo: {},
      periodIdDbUse: '',
      periodNameDbUse: '',

      items: [
        {
          ID: 1,
          POSITION: '主任',
          STAFF: 'テスト太郎',
          MAN_POWER_RATE: 50,
          CHALLENGE_RATE: 63,
          MAN_POWER_SUM: 180,
          CHALLENGE_SUM: 193,
          EVALUATION: 78,
        },
      ],

      rankItems: [],

      headers: [
        {
          text: '部署',
          value: 'DEPARTMENT_NAME',
        },
        {
          text: '役職',
          value: 'POSITION_NAME',
        },
        {
          text: '氏名',
          value: 'USER_NAME',
        },
        {
          text: '評価の状態',
          value: 'STATUS',
        },
        {
          text: '人間力(%)',
          value: 'HUMAN_POWER_RATE',
          align: 'right',
        },
        {
          text: 'チャレンジ(%)',
          value: 'CHALLENGE_GOAL_RATE',
          align: 'right',
        },
        {
          text: '人間力合計',
          value: 'HUMAN_POWER_SCORE',
          align: 'right',
        },
        {
          text: 'チャレンジ合計',
          value: 'CHALLENGE_GOAL_SCORE',
          align: 'right',
        },
        {
          text: '評価点数',
          value: 'EVALUATION_SCORE',
          align: 'right',
        },
        {
          text: '評価',
          value: 'RANK_SETTING_NAME',
          width: '10%',
        },
      ],
    };
  },
  props: {
    periodId: {
      type: [String, String],
      required: true,
    },
    periodName: {
      type: [String, String],
      required: true,
    },
  },

  created() {
    this.periodIdDbUse = Buffer.from(this.periodId, 'base64').toString();
    this.periodNameDbUse = Buffer.from(this.periodName, 'base64').toString();
    // データ取得
    this.get_evaluation();
  },

  methods: {
    async get_evaluation() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      let vm = this;
      this.loading = true;

      // ログインユーザランク
      var loginUserRannk = userInfo.USER_RANK;
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // シスオペでログインした場合、TOP権限で検索
        loginUserRannk = config.USER_RANK_TOP;
      }

      // ランク取得
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/rank/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // ランク設定データ取得
          vm.rankItems = response.data;

          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/sumlist/detail/' +
                userInfo.SESSION_ID +
                '/' +
                userInfo.USER_ID +
                '/' +
                this.periodIdDbUse +
                '/' +
                loginUserRannk
            )
            .then((response) => {
              this.loading = false;
              // 評価データ取得
              vm.items = response.data;
              for (var i = 0; i < vm.items.length; i++) {
                // 状態
                vm.items[i].STATUS = convertEvaluationStatus(
                  vm.items[i].EVAL_STATUS
                );
                // ランク設定
                var finalScore = Number(vm.items[i].EVALUATION_SCORE);
                for (var j = 0; j < vm.rankItems.length; j++) {
                  var rankScoreStart = Number(vm.rankItems[j].RANK_SCORE_START);
                  var rankScoreEnd = Number(vm.rankItems[j].RANK_SCORE_END);
                  if (
                    finalScore >= rankScoreStart &&
                    finalScore <= rankScoreEnd
                  ) {
                    vm.items[i].RANK_SETTING_NAME =
                      vm.rankItems[j].RANK_SETTING_NAME;
                    break;
                  }
                }
              }
            })
            .catch((error) => {
              this.loading = false;
              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM + error;
                this.$refs.dialog.open('error', errStr);
              }
            });
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
  },
};
</script>
